import { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { AdminPublicInfo } from '../../Api/Admin/models'
import { GetCbuResponse } from '../../Api/CBU/models'
import { fetchStaticButton } from '../../Api/Buttons/Buttons'
import { Button } from '../../Api/Buttons/models'
import toast from 'react-hot-toast';
import { useGetTimeForHistory } from '../Coins/useGetTimeForHistory';
import { createUser, createUserInPromo } from '../../Api/UserPanel/UserPanel';

interface Props {
    adminInfo: AdminPublicInfo | null
    setForm: (form: any) => void
    setLoading: (loading: boolean) => void
    setDropdownOpen: (dropdownOpen: boolean) => void
    fetchedData: GetCbuResponse | null
    form: any
    loading: boolean
    setHistorial: (historial: any[]) => void
    historial: any[]
    setErrorQuantities: (errorQuantities: number) => void
    errorQuantities: number
    showHistory: boolean
    setShowHistory: (showHistory: boolean) => void
    useRandomNumber: boolean
}


export const useCreateUser = ({
    setForm,
    setLoading,
    form,
    loading,
    setHistorial,
    historial,
    setErrorQuantities,
    errorQuantities,
    showHistory,
    setShowHistory,
    adminInfo,
    useRandomNumber
}: Props) => {
    const { getTime } = useGetTimeForHistory()

    const [messagesCreateUser, setMessagesCreateUser] = useState<Button>({
        id: '',
        name: '',
        category: '',
        createdAt: '',
        updatedAt: '',
        OwnerId: '',
        Messages: []
    })


    // MAIN FUNCTION
    const handleCreateUser = async ({ createdInPromo }: { createdInPromo?: boolean }) => {
        if (loading) { return }
        if (form.name.length > 13) { Swal.fire('Máximo 13 carácteres para crear usuarios.'); return }
        if (form.name.length < 3) { Swal.fire({ text: 'Ingresa al menos tres letras.' }); return }

        setLoading(true)
        let randomN = useRandomNumber ? Math.floor(Math.random() * (99 - 1) + 1) : ''
        let full_user = `${adminInfo?.firstLetter ?? ''}${form.name.replace(' ', '').trim() + randomN}`

        const copyMessage = async (text: string) => {
            await navigator.clipboard.writeText(text)
            let updatedMessage = text
                .replaceAll('__USUARIO__', (full_user))
                .replaceAll('__PASSWORD__', adminInfo?.default_users_password ?? 'hola123')
                .replaceAll('__LINK__', `${adminInfo?.pageLink}`)

            await navigator.clipboard.writeText(updatedMessage);
        }

        let randomIndex = Math.floor(Math.random() * messagesCreateUser?.Messages?.length);
        let randomValue = messagesCreateUser?.Messages[randomIndex];
        if (randomValue) copyMessage(randomValue.text)


        setForm({ name: '' })

        if (createdInPromo) {
            await createUserInPromo({ platformUser: full_user })
        }

        try {
            const result = await createUser({ name: full_user, password: adminInfo?.default_users_password ?? 'hola123', })
            if (!result.data.includes('ERROR')) {
                toast.success(`Usuario ${full_user} creado`)
                let record = { user: full_user, hour: getTime(), success: true, type: 'Crear' }
                setHistorial([...historial, record])

            } else {
                let record = { user: full_user, hour: getTime(), success: false, type: 'Crear', info: result.data }
                setHistorial([...historial, record])
                if (!showHistory) setErrorQuantities(errorQuantities + 1)
                const errorMessage = result?.response?.data?.msg ?? result?.data ?? 'Ha habido un error. Reinicia o preuba con otro nombre.'
                Swal.fire({ icon: 'error', text: errorMessage });
            }
        } catch (error: any) {
            let errorMessage = `ERROR: No se ha podido crear, el usuario ${full_user} ya existe, o ha habido un error de conexión.`
            if (error?.response?.data?.msg) {
                errorMessage = error.response.data.msg
            }
            let record = { user: full_user, hour: getTime(), success: false, type: 'Crear', info: errorMessage }
            setHistorial([...historial, record])
            if (!showHistory) setErrorQuantities(errorQuantities + 1)
            Swal.fire({ icon: 'error', text: errorMessage });
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchStaticButton('static_newuser').then((res) => {
            setMessagesCreateUser(res)
        })
    }, [])


    return {
        handleCreateUser,
        historial,
        errorQuantities,
        showHistory,
        setShowHistory,
        setErrorQuantities
    }

}
